"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResource = exports.createNote = void 0;
class Loadable {
    constructor(o, load) {
        this.load = load;
        this.loaded = false;
        this.o = o;
    }
    awaitLoad() {
        if (!this.loaded && this.load) {
            this.load(this.o);
        }
        this.loaded = true;
    }
}
function loadable(properties) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return function (o, load) {
        const l = new Loadable(o, load);
        for (const property of Object.keys(properties)) {
            Object.defineProperty(l, property, {
                get: function () {
                    if (l.o[property] || l.o[property] === null)
                        return l.o[property];
                    l.awaitLoad();
                    return l.o[property];
                },
                set: function (value) {
                    l.o[property] = value;
                }
            });
        }
        return l;
    };
}
const propsNote = {
    title: undefined, content: undefined, author: undefined,
    tags: undefined, resources: undefined, created: undefined,
    updated: undefined, latitude: undefined, longitude: undefined
};
const loadableNote = loadable(propsNote);
function createNote(props, load) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allProps = {};
    for (const key of Object.keys(propsNote)) {
        allProps[key] = undefined;
    }
    if (props) {
        for (const key of Object.keys(props)) {
            allProps[key] = props[key];
        }
    }
    return loadableNote(allProps, load);
}
exports.createNote = createNote;
const propsResource = {
    url: undefined,
    dataStream: undefined,
    filename: undefined,
    mimetype: undefined,
    width: undefined,
    height: undefined,
    base64data: undefined,
    md5: undefined
};
const loadableResource = loadable(propsResource);
function createResource(props, load) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allProps = {};
    for (const key of Object.keys(propsResource)) {
        allProps[key] = undefined;
    }
    if (props) {
        for (const key of Object.keys(props)) {
            allProps[key] = props[key];
        }
    }
    return loadableResource(allProps, load);
}
exports.createResource = createResource;
